import React from 'react';
import { Modal } from './Modal';
import { X } from 'lucide-react';
import { useTranslation } from '~/lib/hooks/useTranslation';
import PricingSection from './PricingSection';
import { useRouteLoaderData } from '@remix-run/react';
import { useStore } from '@nanostores/react';
import { userStore } from '~/lib/stores/user';
import TopUpContent from './TopUpContent';
import type { ServerLoaderData } from '~/root';

import { buildUpgradeCheckoutUrl } from '~/lib/billing/offerCheckout';

interface ProUpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  isTopUp?: boolean;
  paymentUrl: string;
}

export const ProUpgradeModal: React.FC<ProUpgradeModalProps> = ({ isOpen, onClose, paymentUrl, isTopUp }) => {
  const { t } = useTranslation();

  const planName = useStore(userStore).planName;
  const rootData = useRouteLoaderData('root') as ServerLoaderData;
  const token = rootData?.token || '';
  const currency = rootData?.currency || 'USD';
  const showAddTopUp = planName.includes('Pro') && isTopUp;

  const finalCurrency = currency === 'INR' ? 'INR' : 'USD';

  // console.info('Final currency and currency from root loader [ProUpgradeModal]:', finalCurrency, currency);

  const buttonCTA = (
    billingCycle: 'Monthly' | 'Yearly',
    planName: 'Pro' | 'Launch',
    isOfferActive: boolean = false,
  ) => {
    window.location.href = buildUpgradeCheckoutUrl({
      paymentUrl,
      token,
      billingPeriod: billingCycle,
      currency: finalCurrency,
      planName,
      isOfferActive,
    });
  };

  const handleScrollToTop = () => {
    // Close modal and let user interact with pricing
    onClose();
  };

  const handleContactSales = () => {
    window.open('https://calendar.app.google/sAggpvWcDjTWUasj9', '_blank');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="fixed inset-0 backdrop-blur-xs z-modal" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-51 bg-white rounded-2xl shadow-2xl overflow-hidden flex w-[90vw] h-[90vh] md:w-[80vw] md:h-[80vh] lg:w-[70vw] lg:h-[80vh] xl:w-[70vw] xl:h-[80vh]">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-black/70 hover:text-black bg-black/10 hover:bg-black/20 rounded-full transition-all duration-200"
          aria-label="Close"
        >
          <X size={20} />
        </button>

        {/* Pricing Section with Scroll */}
        {showAddTopUp ? (
          <div className="flex-1 overflow-y-auto -mt-12">
            <TopUpContent token={token} paymentUrl={paymentUrl} currency={finalCurrency} />
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto -mt-12">
            <PricingSection
              currency={currency}
              isCollapsed={true}
              onScrollToTop={handleScrollToTop}
              onContactSales={handleContactSales}
              buttonCTA={buttonCTA}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ProUpgradeModal;
